import { withSentry } from '../../modules/sentry';
import $ from 'jquery';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import ProductMetadata from '../../components/ProductMetadata/ProductMetadata.vue';
import preprocessProps from '../../components/ProductMetadata/preprocess_props';
import { updateVariantImages } from '../../modules/variant_images';

$(function () {
  withSentry(() => {
    console.log('PDP page');
    Vue.use(vueCustomElement);
    Vue.customElement('pxl-product-metadata', ProductMetadata, preprocessProps);

    $(document).on('pxlVariantChange', (event) => {
      const { data } = event.detail;
      updateVariantImages(data);
    });
  });
});
